import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import { AxiosError } from 'axios';
import { RootState } from '../../../app/store/configureStore';
import Restaurant from '../../../app/data/models/restaurant';

export const fetchWaiterRestaurantListAsync = createAsyncThunk(
  'restaurantWaiter/fetchRestaurant',
  async (
    {
      pageNumber = 1,
      pageSize = 10,
    }: { pageNumber?: number; pageSize?: number },
    thunkApi
  ) => {
    try {
      return await api.RestaurantWaiter.restaurants(pageNumber, pageSize);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return thunkApi.rejectWithValue({ error: error.response?.data });
      }
      return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

const waiterRestaurantsAdapter = createEntityAdapter<Restaurant>();

export const waiterRestaurantSlice = createSlice({
  name: 'waiterRestaurant',
  initialState: waiterRestaurantsAdapter.getInitialState({
    restaurantsLoaded: false,
    status: 'idle',
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaiterRestaurantListAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchWaiterRestaurantListAsync.fulfilled, (state, action) => {
        if (action.payload && action.payload.data) {
          waiterRestaurantsAdapter.setAll(state, action.payload.data);
          state.restaurantsLoaded = true;
        } else {
          console.error('No data found in payload:', action.payload);
        }
        state.status = 'idle';
      })
      .addCase(fetchWaiterRestaurantListAsync.rejected, (state) => {
        state.status = 'idle';
      });
  },
});

export const waiterRestaurantsSelectors = waiterRestaurantsAdapter.getSelectors(
  (state: RootState) => state.waiterRestaurants
);
